export default __webpack_public_path__ + "static/media/activeListView.fd6c8fe3.svg";